export default __webpack_public_path__ + "static/media/nasa_genelab_cert.5d81de3f.jpg";